import CssBaseline from '@material-ui/core/CssBaseline'
import 'fontsource-roboto'
import React from 'react'
import 'url-search-params-polyfill'

import ParedApp from 'pared/ParedApp'

class ErrorBoundary extends React.Component<{}, { hasError: boolean }> {
  constructor(props: {}) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <h1>
          Unexpected Error. Please try again or contact support@getexpo.com.
        </h1>
      )
    }

    return this.props.children
  }
}

function App() {
  return (
    <ErrorBoundary>
      <CssBaseline />
      <ParedApp />
    </ErrorBoundary>
  )
}

export default App
